import React from 'react';
import { Box, Button, SxProps, Theme } from '@mui/material';
import { CANCEL_LINK_BUTTON_SX } from './sharedStyles';

type Props = {
  label: string;
  busy: boolean;
  onClick: () => void;
  // Outer Box override (e.g. left indent to align with parent content).
  boxSx?: SxProps<Theme>;
};

// Shared cancel-affordance row used under owned Tier/Env cards.
// Renders a top divider + text button. Visual styling is identical
// across consumers — they only differ in how the row is indented.
export function CancelLinkRow({ label, busy, onClick, boxSx }: Props) {
  return (
    <Box
      sx={[
        {
          mt: 1,
          pt: 0.5,
          borderTop: '1px solid',
          borderColor: 'divider'
        },
        ...(Array.isArray(boxSx) ? boxSx : [boxSx])
      ]}
    >
      <Button size="small" variant="text" color="error" disabled={busy} onClick={onClick} sx={CANCEL_LINK_BUTTON_SX}>
        {label}
      </Button>
    </Box>
  );
}
